import React from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { Head } from '@shared/components/head';
import { Text } from '@shared/components/text';
import Button from '@shared/components/md-design-system/Button/Button';
import Icon from '@shared/components/md-design-system/Icon/Icon';
import { colorPalette } from '@shared/config/colorsConfig';

type RemeasurementSuccessNavigationProp = NativeStackNavigationProp<any>;

export const RemeasurementSuccessScreen = () => {
  const navigation = useNavigation<RemeasurementSuccessNavigationProp>();
  const { t } = useTranslation();

  const handleReturnToMain = () => {
    navigation.navigate('Homepage');
  };

  return (
    <View className="flex-1 bg-white">
      <View className="flex-1 flex-col justify-between p-8">
        <View className="flex-1 flex-col items-center justify-center gap-6">
          <Icon
            name="check-circle"
            size={80}
            color={colorPalette.success[500]}
          />
          <View className="gap-4">
            <Head type="h1" className="text-center">
              {t('screens.remeasurement.success.header')}
            </Head>
            <Text className="text-center text-gray-600">
              {t('screens.remeasurement.success.text')}
            </Text>
          </View>
        </View>

        <View className="pt-6">
          <Button
            variant="primary"
            size="large"
            onPress={handleReturnToMain}
          >
            {t('buttons.returnToMain')}
          </Button>
        </View>
      </View>
    </View>
  );
};

export default RemeasurementSuccessScreen;
